import axios from "axios";

export const API_BASE_URL = process.env.API_BASE_URL || "https://sabji-api.namashkarfuel.com/api";

export const api = axios.create({
    baseURL: API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});
